'use client'

import granditudeLogo from '#/src/images/granditude_logo.png'
import { ImageBox } from 'ui'
import { useAppConfigContext } from '#/src/appConfig'

export const FooterLogo = () => {
  const appConfig = useAppConfigContext()
  const { imageProps, ...themeProps } = appConfig.theme?.components?.FooterLogo ?? {}

  return (
    <ImageBox
      imageProps={{
        title: 'logo',
        alt: 'logo',
        src: appConfig.logoUrl || granditudeLogo.src,
        style: {
          objectFit: 'contain'
        },
        quality: 100,
        priority: true,
        sizes: '10rem',
        ...imageProps
      }}
      h="2.5rem"
      w="10rem"
      {...themeProps}
    />
  )
}
